module.exports = __webpack_public_path__ + "static/media/coco-collective-1.6d666fe1.png";